import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { CardAccountTransferScheduleAmountData } from '@acre-rewards/lib'
import { z } from 'zod/v4'
import type { BasePaymentMethod } from '@/src/experiences/card-payments/providePaymentMethods'

type CardAccountTransferScheduleAmountDataType = z.infer<
  typeof CardAccountTransferScheduleAmountData
>

type IsoDateTime = z.infer<ReturnType<typeof z.iso.datetime>>

export interface RecurringPaymentStore {
  paymentStrategy: CardAccountTransferScheduleAmountDataType
  setPaymentStrategy: (paymentStrategy?: CardAccountTransferScheduleAmountDataType) => void
  day: IsoDateTime | undefined
  setDay: (date: RecurringPaymentStore['day']) => void
  account: BasePaymentMethod | undefined
  setAccount: (account: RecurringPaymentStore['account']) => void
  clear: () => void
}

export const useRecurringPaymentStore = create(
  persist<RecurringPaymentStore>(
    (set) => ({
      paymentStrategy: { amountType: 'min' },
      day: undefined,
      account: undefined,
      setPaymentStrategy: (paymentStrategy) => set({ paymentStrategy }),
      setDay: (day) => set({ day }),
      setAccount: (account) => set({ account }),
      clear: () =>
        set({ paymentStrategy: { amountType: 'min' }, day: undefined, account: undefined }),
    }),
    {
      name: 'recurring-payment',
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
)
